export const ACCESS_TOKEN = 'ls_authorization'
export const LAST_OPER_TIME = 'ls_opertime'
export const LOGIN_USER_STATE = 'ls_state'